module.exports = __webpack_public_path__ + "static/img/daily-warn.0cfe72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/daily-warn.png
// module id = 9FSX
// module chunks = 58